import { render, staticRenderFns } from "./downloadnew.vue?vue&type=template&id=6f062a5d&scoped=true&"
import script from "./downloadnew.vue?vue&type=script&lang=js&"
export * from "./downloadnew.vue?vue&type=script&lang=js&"
import style0 from "./downloadnew.vue?vue&type=style&index=0&id=6f062a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f062a5d",
  null
  
)

export default component.exports